import React, { useEffect, useRef, useState } from 'react';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenu, IonMenuButton, IonPage, IonSpinner, IonTitle, IonToolbar } from '@ionic/react';
import { useLocation, useParams } from 'react-router';


import "./Home.css";

import '../components/ExploreContainer.css';
import '../components/1440.css';
import '../components/1024.css';
import '../components/992.css';
import '../components/768.css';
import '../components/700.css';
import '../components/425.css';
import '../components/375.css';
import '../components/320.css';


import ClassTwoMenu from '../menus/ClassTwo/ClassTwo';
import ClassThreeMenu from '../menus/ClassThree/ClassThree';
import ClassFourMenu from '../menus/ClassFour/ClassFour';
import ClassFiveMenu from '../menus/ClassFive/ClassFive';
import ClassOneMenu from '../menus/ClassOne/ClassOne';
import UKGMenu from '../menus/UKG/UKG';
import LKGMenu from '../menus/LKG/LKG';
import NurseryMenu from '../menus/Nursery/Nursery';
import GerundsExercise from '../components/ClassOne/English/GerundsExercise';
import GerundsMenu from '../menus/ClassOne/Gerunds';


import UKG from '../components/UKG';
import LKG from '../components/LKG';
import Nursery from '../components/Nursery';
import ClassOne from '../components/ClassOne';
import ClassTwo from '../components/ClassTwo';
import ClassThree from '../components/ClassThree';
import ClassFour from '../components/ClassFour';
import ClassFive from '../components/ClassFive';


import OlympiadClassOne from '../components/Olympiad/ClassOne';
import OlympiadClassTwo from '../components/Olympiad/ClassTwo';
import OlympiadClassThree from '../components/Olympiad/ClassThree';
import OlympiadClassOneMenu from '../menus/Olympiad/ClassOne';
import OlympiadClassTwoMenu from '../menus/Olympiad/ClassTwo';
import OlympiadClassThreeMenu from '../menus/Olympiad/ClassThree';
import LogicalReasoning from '../components/LogicalReasoning';
import LogicalReasoningMenu from '../menus/LogicalReasoning';

import ContactUs from './ContactUs';
import PrivacyPolicy from './PrivacyPolicy';



import { downloadOutline } from 'ionicons/icons';
import { downloadDivAsPDF } from './pdfGenerator'; // Adjust path as needed
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import { color } from 'html2canvas/dist/types/css/types/color';
import IMO from '../components/Olympiad/IMO';



interface ChildProps {
    pagetitle: string;
}

const Page: React.FC<ChildProps> = ({ pagetitle }) => {

    // Use useLocation to check the current URL path
    const location = useLocation();
    const myContainerRef = useRef<HTMLDivElement | null>(null);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        const element = document.getElementsByClassName("selected")[0];
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth', // Smooth scrolling animation
                block: 'center',    // Align the item in the center of the viewport
            });
        }
    }, [location.pathname])




    const handleDownload = async () => {
        if (!myContainerRef.current) return;
        setIsLoading(true);
        try {
            await downloadDivAsPDF(myContainerRef.current);
        } catch (err) {
            console.error('PDF download failed', err);
        }
        setIsLoading(false);
    };

    

    return (
        <IonPage className='innerPage'>
            <IonMenuButton style={{ 'position': 'absolute', 'top': '25px', 'z-index': '999', color: 'rgb(149, 56, 124)' }} />
            <IonContent scrollEvents={false} fullscreen>
                <div className='container-fluid fullPageContainer'>
                    <div className='my-home-container side-menu'>
                        <div className='home-card'>
                            <div id="mainContent">
                                <div className='headerSection'>
                                    <div className="logo d-lg-none d-md-block">
                                        <a href="/"><img src="assets/logo-minified.png" alt="" className='topLogo' /></a>
                                    </div>
                                    <div className='siteName font-weight-bold font-25 d-lg-none d-md-flex'>
                                        <span className="yellowText">Mamas</span> &nbsp;
                                        <span className="orangeText">Guidance</span>
                                    </div>
                                    <div className='text-right d-none d-lg-block social-media' style={{ width: '100%' }}>
                                        <a href='https://www.facebook.com/profile.php?id=61577840330706' target='_blank' rel="noreferrer" style={{ marginRight: '20px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="5vh" height="5vh" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                                                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                                            </svg>
                                        </a>
                                        <a href='https://x.com/MamasGuidance' target='_blank' rel="noreferrer" style={{ marginRight: '20px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="5vh" height="5vh" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                                            </svg>
                                        </a>
                                        <a href='https://www.instagram.com/mamas.guidance/' target='_blank' rel="noreferrer" style={{ marginRight: '20px' }}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                width="5vh" height="5vh"
                                            >
                                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                                <path d="M16 11.37a4 4 0 1 1-7.9 1.18 4 4 0 0 1 7.9-1.18z"></path>
                                                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5"></line>
                                            </svg>
                                        </a>
                                        <a href='https://www.youtube.com/channel/UCCAToEWU7aJAVOlTlEX_6XA' rel="noreferrer" target='_blank' style={{ marginRight: '20px' }}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                width="5vh" height="5vh"
                                            >
                                                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-2C18.88 4 12 4 12 4s-6.88 0-8.59.42a2.78 2.78 0 0 0-1.95 2A29.94 29.94 0 0 0 1 12a29.94 29.94 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 2C5.12 20 12 20 12 20s6.88 0 8.59-.42a2.78 2.78 0 0 0 1.95-2A29.94 29.94 0 0 0 23 12a29.94 29.94 0 0 0-.46-5.58z"></path>
                                                <polygon points="10 15 15 12 10 9 10 15"></polygon>
                                            </svg>
                                        </a>
                                        {/* <img className='img-fluid' src='assets/google-play.png' style={{ height: '10vh' }} /> */}
                                    </div>
                                </div>
                                <div className='pageContent'>
                                    {/* <div className="float-end" style={{ fontSize: '38px' }} onClick={() => handleDownload()}><i className="fas fa-download"></i></div> */}
                                    {/* <IonButton className='float-end' expand="block" onClick={handleDownload} disabled={isLoading}>
                                        {isLoading ? (
                                            <IonSpinner name="dots" />
                                        ) : (
                                            <>
                                                <IonIcon icon={downloadOutline} slot="start" />
                                            </>
                                        )}
                                    </IonButton> */}
                                    <div className='myContent' ref={myContainerRef}>
                                        {/* <div
                                            style={{
                                                position: 'absolute',
                                                top: '60%',
                                                left: '50%',
                                                fontSize: '40px',
                                                fontWeight: 'bold',
                                                color: 'rgba(200, 200, 200, 0.2)',
                                                transform: 'translate(-50%, -50%) rotate(0deg)',
                                                pointerEvents: 'none',
                                                userSelect: 'none',
                                                whiteSpace: 'nowrap',
                                                zIndex: 0, // this ensures it's behind
                                            }}
                                        >
                                            <img className='img-fluid height-30' src='assets/logo.png' style={{ opacity: 0.1 }} />
                                            Mama&apos;s Guidance
                                        </div> */}
                                        {
                                            location.pathname == '/contact-us' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Contact Us</h1>
                                                    </div>
                                                    <ContactUs />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/nursery' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Nursery</h1>
                                                    </div>
                                                    <Nursery />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/lkg' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>LKG</h1>
                                                    </div>
                                                    <LKG />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/ukg' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>UKG</h1>
                                                    </div>
                                                    <UKG />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/class-one' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 1</h1>
                                                    </div>
                                                    <ClassOne />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/class-two' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 2</h1>
                                                    </div>
                                                    <ClassTwo />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/class-three' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 3</h1>
                                                    </div>
                                                    <ClassThree />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/class-four' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 4</h1>
                                                    </div>
                                                    <ClassFour />
                                                </>
                                            )}
                                        
                                        {
                                            location.pathname == '/class-five' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 5</h1>
                                                    </div>
                                                    <ClassFive />
                                                </>
                                            )}

                                        {
                                            location.pathname == '/logical-reasoning' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Logical Reasoning</h1>
                                                    </div>
                                                    <LogicalReasoning />
                                                </>
                                            )}

                                        {
                                            location.pathname == '/olympiad-classone' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 1</h1>
                                                    </div>
                                                    <OlympiadClassOne />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/olympiad-classtwo' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 2</h1>
                                                    </div>
                                                    <OlympiadClassTwo />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/olympiad-classthree' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Class 3</h1>
                                                    </div>
                                                    <OlympiadClassThree />
                                                </>
                                            )}
                                        {
                                            location.pathname == '/class-one/english/nouns/gerunds/exercise' && (
                                                <>
                                                    <div className='text-center'>
                                                        <h1 className='font-50'>Gerunds Exercise</h1>
                                                    </div>
                                                    <GerundsExercise />
                                                </>
                                            )}
                                        {
                                            GerundsMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        {
                                            NurseryMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        {
                                            LKGMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        {
                                            UKGMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        {
                                            ClassOneMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        {
                                            ClassTwoMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        
                                        {
                                            ClassThreeMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        
                                        {
                                            ClassFourMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        
                                        {
                                            ClassFiveMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}


                                        {
                                            OlympiadClassOneMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        {
                                            OlympiadClassTwoMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        
                                        {
                                            OlympiadClassThreeMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}

                                        
                                        {
                                            LogicalReasoningMenu.map((route, index) => {
                                                const MenuComponent = route.component;
                                                // Check if the component exists and render it if the URL matches
                                                if (location.pathname === route.url && MenuComponent) {

                                                    return (
                                                        <>
                                                            <div className='text-center'>
                                                                <h1 className='font-50'>{route.title}</h1>
                                                            </div>
                                                            <MenuComponent key={index} />
                                                        </>
                                                    );
                                                }

                                                // If the route has submenus, iterate over them
                                                if (route.subMenu) {
                                                    return route.subMenu.map((subroute, subindex) => {
                                                        const SubMenuComponent = subroute.component;
                                                        // Check if the submenu component exists and render it if the URL matches
                                                        if (location.pathname === subroute.url && SubMenuComponent) {
                                                            return (
                                                                <>
                                                                    <div className='text-center'>
                                                                        <h1 className='font-50'>{subroute.title}</h1>
                                                                    </div>
                                                                    <SubMenuComponent key={subindex} />
                                                                </>
                                                            );
                                                        }

                                                        // If the route has submenus, iterate over them
                                                        if (subroute.subMenu) {
                                                            return subroute.subMenu.map((subsubroute, subsubindex) => {
                                                                const SubSubMenuComponent = subsubroute.component;
                                                                // Check if the submenu component exists and render it if the URL matches
                                                                if (location.pathname === subsubroute.url && SubSubMenuComponent) {
                                                                    return (
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h1 className='font-50'>{subsubroute.title}</h1>
                                                                            </div>
                                                                            <SubSubMenuComponent key={subsubindex} />
                                                                        </>
                                                                    );
                                                                }

                                                                // Return null if no matching submenu component
                                                                return null;
                                                            });
                                                        }

                                                        // Return null if no matching submenu component
                                                        return null;
                                                    });
                                                }

                                                return null;

                                            }
                                            )}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};



export default Page;
